import Icon, { type IconName } from '@utilities/icon';
import classNames from 'classnames';
import Image from 'next/image';

interface ImageOptionProps {
  label: string;
  image?: string;
  isActive?: boolean;
  onClick?: () => void;
  icon?: IconName;
  iconColor?: string;
  labelClassname?: string;
  width?: number;
  height?: number;
  isCircle?: boolean;
  rootClassName?: string;
  imageClassName?: string;
  hasHover?: boolean;
}

const ImageOption = ({
  label,
  image,
  onClick,
  isActive = false,
  icon,
  iconColor,
  labelClassname,
  width = 70,
  height = 68,
  isCircle,
  rootClassName,
  imageClassName,
  hasHover = true,
}: ImageOptionProps) => {
  return (
    <div
      onClick={onClick}
      className={classNames(
        'h-full flex flex-col items-center justify-center rounded-xl select-none transition-all duration-200 self-start',
        rootClassName,
      )}
    >
      <div
        className={classNames(
          'flex items-center justify-center overflow-hidden bg-surface-secondary mb-2',
          isActive && 'border border-content-primary',
          isCircle ? 'rounded-full' : 'rounded-lg',
          hasHover && 'hover:bg-surface-tertiary',
        )}
        style={{ width, height, maxWidth: width }}
      >
        {image ? (
          <Image
            src={image}
            width={width}
            height={height}
            alt={label}
            className={classNames('w-full h-full object-cover', imageClassName)}
          />
        ) : icon ? (
          <Icon name={icon} width={1.5} height={1.5} fill={iconColor} />
        ) : (
          <Image
            src="/images/emptyImage.png"
            alt={label}
            width={width}
            height={height}
          />
        )}
      </div>

      <span
        className={classNames(
          'text-Label/xSmall text-center leading-tight line-clamp-2',
          labelClassname,
        )}
        style={{ width }}
      >
        {label}
      </span>
    </div>
  );
};

export default ImageOption;
